/**
 * Centralized timing constants for potion game UI components
 * All delays in milliseconds for consistency
 */

export const UI_TIMING = {
  // Video sequence timing (must match backend timing)
  SCREEN_SMOKE_DURATION: 3000,               // Screen smoke effect duration  
  POTION_VIDEO_DURATION: 6000,               // Time for potion video to play
  AI_COMMENTARY_DURATION: 8000,              // Time for AI to provide commentary (8s to prevent audio cutoff)
  
  // Button interaction delays
  BUTTON_STATE_CHANGE_DELAY: 100,            // Short delay for button state changes
  PREPARATION_DELAY: 200,                    // Time to prepare UI for next state
  
  // Video management
  VIDEO_FADE_DURATION: 500,                  // Duration for video fade transitions
  VIDEO_END_BUFFER: 200,                     // Buffer time after video ends
  
  // Calculated composite timings
  get TOTAL_POTION_SEQUENCE() {
    return this.SCREEN_SMOKE_DURATION + this.POTION_VIDEO_DURATION + this.AI_COMMENTARY_DURATION;
  }
} as const;

/**
 * Type-safe UI timing configuration keys
 */
export type UITimingKey = keyof typeof UI_TIMING;